module.exports = __webpack_public_path__ + "img/dislike-yellow.e4fe8b83.svg";